export default class ActionName {
    public static GET: string;

    public static UPDATE: string;

    public static LOGIN:string = '/api/v1/login';

    public static IS_LOGIN:string = '/api/v1/is_login';

    public static GET_USER_INFO:string = 'api/v2/site/users/me';

    public static PREREGIST:string = 'api/signup/preregist.json';

  /**
     * コンスト
     */
  /* constructor() {

    } */
}
